import React from 'react';
import Input from '../input/Input';
import InputNumber from '../input/InputNumber';
import InputData from '../input/InputData';
import InputSelect from '../input/InputSelect';

var FilterTypeEnum = {
    TEXT: {
        enumName: 'TEXT',        
        component: function(props, item, index) {
            return (
                <Input
                    key={index}
                    md={(item.md ? item.md : 12)} 
                    xs={(item.xs ? item.xs : 12)} 
                    sm={(item.sm ? item.sm : 12)} 
                    lg={(item.lg ? item.lg : 12)} 
                    id={item.campo}
                    nome={item.campo}                    
                    value={item.valor}
                    defaultValue={item.valor}
                    defaultFoco={true}
                    onChange={e => props.onChange(index, e)}                    
                >
                    {item.nome}
                </Input>             
            )
        }
    },    
    DATE: {
        enumName: 'DATE',        
        component: function(props, item, index) {
            return (
                <InputData
                    key={index}
                    md={(item.md ? item.md : 12)} 
                    xs={(item.xs ? item.xs : 12)} 
                    sm={(item.sm ? item.sm : 12)} 
                    lg={(item.lg ? item.lg : 12)} 
                    id={item.campo}
                    nome={item.campo}                    
                    value={item.valor}
                    defaultValue={item.valor}   
                    defaultFoco={true}
                    onChange={e => props.onChange(index, e)}                    
                >
                    {item.nome}
                </InputData>             
            )
        }
    },  
    SELECT: {
        enumName: 'SELECT',        
        component: function(props, item, index) {
            return (                
                <InputSelect 
                    key={index}
                    md={(item.md ? item.md : 12)} 
                    xs={(item.xs ? item.xs : 12)} 
                    sm={(item.sm ? item.sm : 12)} 
                    lg={(item.lg ? item.lg : 12)}                                         
                    id={item.campo}
                    nome={item.campo}                    
                    value={item.valor}
                    defaultValue={item.valor}                    
                    options={item.options}                    
                    onChange={e => props.onChangeSelect(index, e)}
                >                            
                    {item.nome}
                </InputSelect>
            )
        }
    },
    NUMBER: {
        enumName: 'NUMBER',        
        component: function(props, item, index) {
            return (
                <InputNumber
                    key={index}
                    md={(item.md ? item.md : 12)} 
                    xs={(item.xs ? item.xs : 12)} 
                    sm={(item.sm ? item.sm : 12)} 
                    lg={(item.lg ? item.lg : 12)} 
                    id={item.campo}
                    nome={item.campo}                    
                    value={item.valor}
                    defaultValue={item.valor}
                    onChange={e => props.onChange(index, e)}                    
                >
                    {item.nome}
                </InputNumber> 
            )
        }
    },    
    get(value) {              
        if(value === null)
            return FilterTypeEnum.TEXT;

        var array = Object.values(FilterTypeEnum);
        var filterTypeEnumFound = {};

        array.forEach(element => {            
            if(element.enumName === value) {
                filterTypeEnumFound = element;      
                return ;          
            }            
        });   
        
        return filterTypeEnumFound;
    },    
}

export default FilterTypeEnum;